import React from 'react';

function KPICard({ title, value, icon, color = 'primary', subtitle, trend, onClick }) {
  return (
    <div 
      className={`card border-start border-${color} border-4 h-100 hover-lift ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : {}}
    >
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <div className="text-muted small mb-1">{title}</div>
            <div className={`h3 mb-0 text-${color}`}>
              {value}
              {trend && (
                <small className={`ms-2 ${trend > 0 ? 'text-success' : 'text-danger'}`}>
                  <i className={`bi bi-arrow-${trend > 0 ? 'up' : 'down'}`}></i>
                  {Math.abs(trend)}%
                </small>
              )}
            </div>
            {subtitle && <div className="text-muted small mt-1">{subtitle}</div>}
          </div>
          {icon && (
            <div className={`text-${color} opacity-50`}>
              <i className={`bi ${icon}`} style={{ fontSize: '2rem' }}></i>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default KPICard;
